import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginService } from '../../../plugins/services/plugin.service';
import { SettingService } from '../../../settings/services/setting.service';
import { ChassisFormHandler } from '../../../forms/form/classes/form-handler';
import { RouteService } from '../../../routing/services/route.service';
import { ToastService } from '../../../toast/services/toast.service';
import { Collection } from '../../../support/collection/collection';

@Component({
    selector: 'chassis-settings-index',
    templateUrl: './settings.page.html',
    styleUrls: ['./settings.page.scss']
})
export class SettingsPage implements OnInit, OnDestroy {

    /**
     * The mode of the page that is being shown
     *
     * Available ptions:
     * create
     * edit
     * show (?)
     *
     * @type {string}
     */
    protected pageMode = 'edit';

    /**
     * The singular form of the model
     *
     * @type {string}
     */
    protected singular = 'setting';

    /**
     * The plural form of the model
     *
     * @type {string}
     */
    protected plural = 'settings';

    /**
     * The title of the page
     *
     * @type {string}
     */
    protected title = this.plural;

    /**
     * The route prefix for the buttons
     *
     * @type {string}
     */
    protected routePrefix = this.plural;

    /**
     * The plugin slot prefix.
     *
     * @type {string}
     */
    protected pluginPrefix = 'chassis-settings';

    /**
     * The ChassisFormHandler form instance.
     */
    public form: ChassisFormHandler;

    /**
     * The settings data.
     *
     * @type {SettingModel}
     */
    public model: Object = {};

    /**
     * The toolbar object.
     */
    protected toolbar;

    /**
     * The SettingService instance.
     */
    protected settingService: SettingService;

    /**
     * The RouteService instance.
     */
    protected routeService: RouteService;

    /**
     * The ActivatedRoute instance.
     */
    protected activatedRoute: ActivatedRoute;

    /**
     * The PluginService instance.
     */
    protected pluginService: PluginService;

    /**
     * The ToastService instance.
     */
    protected toastService: ToastService;

    /**
     * Constructor.
     *
     * @param {Injector} injector
     */
    constructor(protected injector: Injector) {
        this.settingService = this.injector.get(SettingService);
        this.routeService   = this.injector.get(RouteService);
        this.activatedRoute = this.injector.get(ActivatedRoute);
        this.pluginService  = this.injector.get(PluginService);
        this.toastService   = this.injector.get(ToastService);
    }

    /**
     * OnInit.
     */
    public ngOnInit() {
        this.createToolbar();
        this.createForm();
    }

    public createToolbar() {
        this.toolbar = {
            buttons: {
                submit: {
                    callback: (resolve, reject) => {
                        this.form.success((model) => {

                            return new Promise((resolve2) => {
                                resolve();
                                resolve2();
                            });

                        });

                        this.form.error(() => {

                            return new Promise((resolve2, reject2) => {
                                reject();
                                reject2();
                            });

                        });

                        this.form.submit();
                    }
                },
                cancel: false,
                delete: false,
            }
        };
    }

    /**
     * Create the form.
     */
    protected createForm() {
        this.form = new ChassisFormHandler(this.injector, {});

        let built = false;

        // Get the form structure and model.
        this.settingService.custom('get', this.settingService.getEndpointUrl() + '/form').subscribe((structure) => {

            this.settingService.fetched.subscribe((settings) => {
                if (settings instanceof Collection) {
                    this.model = this.map(settings);

                    // Don't re-build the form on save.
                    if (!built) {
                        // Create the form.
                        this.form = new ChassisFormHandler(this.injector, structure, this.model);
                        this.form.build();

                        built = true;

                        // We'll add a custom processor function to handle the submit action.
                        this.form.processor((data, resolve, reject) => {
                            this.settingService.save(data).then(() => {
                                resolve(this.model);
                            }, (error) => {
                                reject(error);
                            });
                        });
                    }
                }
            });
        });
    }

    /**
     * Create a key/value pair list.
     *
     * @param {Collection} collection
     * @returns {{}}
     */
    public map(collection: Collection) {
        return collection.mapWithKeys((item) => {
            let value;

            // When the setting has files we'll add the file ids to the setting value and add the
            // file meta data.
            if (item.files.data && item.files.data.length) {
                const ids = item.files.data.map((item) => {
                    return item.id;
                });

                value = {
                    value: ids,
                    files: item.files ? item.files.data : null,
                };
            } else {
                value = item.value;
            }

            return {
                key: item['name'],
                value: value,
            };
        });
    }

    /**
     * OnDestroy.
     */
    public ngOnDestroy() {
    }


}




// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/pages/settings/index/settings.page.ts